
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ToastsManager } from "ng2-toastr";
import { InventoryContractType } from "../../../../models/CompanyInventory.model";
import { ContractTypesService } from "../../../../services/contractTypes.service";
import { ErrorHandlerProvider } from "../../../../shared/providers/errorHandler.provider";

interface NewContract {
    _id: number;
    name: string;
    active: boolean;
}

@Component({
    selector: 'app-add-contract-type',
    templateUrl: './add-contract-type.component.html',
    styleUrls: ['./add-contract-type.component.scss'],
  })

    export class AddContractTypeComponent implements OnInit {
        @ViewChild("btnCloseModal") btnCloseModalSigners: ElementRef;
        @Output() sendNewContractData = new EventEmitter();
        newContractType: InventoryContractType = {} as InventoryContractType;
        contractName: string;
        namePattern = new RegExp(/^[a-zA-Z\s]+/g);
        constructor(
            private toastr: ToastsManager,
            private contractTypesService: ContractTypesService,
            private errorHandler: ErrorHandlerProvider
        ) {}

        ngOnInit() {}

        isNewContractNameValid(): boolean {
            if (this.contractName === undefined || this.contractName === '') {
                return false;
            }
            if (!this.namePattern.test(this.contractName)) {
                return false
            }
            return true;
        }

        async addNewContract(): Promise<void> {
            if (this.isNewContractNameValid()) {
                try {
                    this.newContractType = await this.contractTypesService.create(this.contractName);
                    if (this.newContractType._id) {
                        this.sendNewContractData.emit(this.newContractType);
                        this.newContractType = {} as InventoryContractType;
                        this.btnCloseModalSigners.nativeElement.click();
                        return;
                    }
                } catch (error) {
                    this.errorHandler.interceptError(error, 'Novo Contrato')
                    this.contractName = '';
                }
            } else {
                this.toastr.error('Nome do contrato inválido', 'Erro');
                this.contractName = '';
                return;
            }
        }
    }



// WEBPACK FOOTER //
// ./src/app/views/companies/company-inventory/modal-add-contract-type/add-contract-type.component.ts